var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"container"},[_c('v-stage',{ref:"stage",attrs:{"config":_vm.configKonva}},[_c('v-layer',_vm._l((this.$store.getters['arrayManagement/getArrayToSort']),function(item){return _c('v-line',{key:item.id,ref:"line{{item.id}}",refInFor:true,attrs:{"config":{
          points: [item.x, 0, item.x, item.y], // x1, y1, x2, y2
          stroke: item.stroke,
          strokeWidth: item.strokeWidth
        }}})}),1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }